import React from 'react'
import { useTranslation } from 'react-i18next'

import './pattern-selector.styles.scss'

const PatternSelector = ({
  pattern,
  localPatterns,
  productType,
  sizeId,
  maxQuantity,
  clickHandler,
  ...otherProps
}) => {
  const { t } = useTranslation('updatedBAB')
  const { id, imageSources, translationKeys } = pattern

  const numberOfSelectedPatterns = localPatterns.filter(
    (patternId) => patternId === pattern.id
  ).length

  const newTag = () => {
    return pattern.new &&
      ` - ${t('pattern.new')}`
  }

  const bestsellerTag = () => {
    return pattern.bestseller &&
      ` - ${t('pattern.bestseller')}`
  }

  const seasonTag = () => {
    return ['spring', 'summer', 'autumn', 'winter'].includes(pattern.collection) &&
      t(`pattern.season.${pattern.collection}`)
  }

  const patternTag = () => {
    return newTag() ||
      bestsellerTag() ||
      seasonTag() ||
      ''
  }

  const patternTitle = () => {
    return t(translationKeys.name) + patternTag()
  }

  return (
    <li className='pattern-selector-container' data-id={id}>
      <div className='pattern-selector'>
        <p className='pattern-title'>{patternTitle()}</p>
        {productType === 'pants' ? (
          <img
            className='pattern-selector-image'
            src={`${imageSources.pants}?width=260`}
            alt={t(translationKeys.imageAlt.pants)}
            width='260'
            height='130'
            loading='lazy'
          />
        ) : (
          <img
            className='pattern-selector-image'
            src={`${imageSources.diapers}?width=260`}
            alt={t(translationKeys.imageAlt.diapers)}
            width='260'
            height='130'
            loading='lazy'
          />
        )}
        <button className='pattern-glass' onClick={clickHandler}>
          <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            stroke='black'
            style={{ strokeLinecap: 'round', strokeLinejoin: 'round' }}
            xmlns='http://www.w3.org/2000/svg'
          >
            <defs />
            <path d='M 16.629 16.9 L 13.578 13.74' />
            <path d='M 7.474 13.738 C 10.845 13.738 13.578 10.909 13.578 7.419 C 13.578 3.929 10.845 1.1 7.474 1.1 C 4.103 1.1 1.371 3.929 1.371 7.419 C 1.371 10.909 4.103 13.738 7.474 13.738 Z' />
          </svg>
        </button>
        {pattern.out_of_stock &&
          <span className='product-img-out-of-stock' />
        }
      </div>
      {pattern.out_of_stock && <p className='pattern-choice-out-of-stock'>{t('pattern.outOfStock')}</p>}
      {!pattern.out_of_stock && <div className='pattern-choice'>
        <button className='pattern-choice-minus'>
          <svg
            width='21'
            height='20'
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='10.5' cy='10' r='9.776' fill='#BEEAD2' />
            <rect
              x='5.612'
              y='9.185'
              width='9.776'
              height='1.629'
              fill='white'
            />
          </svg>
        </button>
        <p className='pattern-choice-quantity'>{numberOfSelectedPatterns}</p>
        <button className='pattern-choice-plus'>
          <svg
            width='21'
            height='20'
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='10.5' cy='10' r='9.776' fill='#BEEAD2' />
            <rect
              x='5.612'
              y='9.186'
              width='9.776'
              height='1.629'
              fill='white'
            />
            <rect x='9.69' y='5.112' width='1.62' height='9.776' fill='white' />
          </svg>
        </button>
      </div>}
    </li>
  )
}

export default PatternSelector
